import Storage from 'store'
import Vue from 'vue'
import { formatDate, getTypeof } from '@/utils'
const MS_OF_HOUR = 3600000

let thisApp = null
const setApp = (app) => {
  thisApp = app
}
export const getTimeOffset = (regionId) => {
  const regionList = JSON.parse(Storage.get('regionList') || '[]')
  const storeRegionId = regionId || Number(thisApp.$cookies.get('storeRegion-id'))
  const offset = regionList
    .find(c => Number(c.regionId) === storeRegionId)?.timeOffset
  if (offset === null || offset === undefined) {
    // 增加判断如果没有时区偏移量 默认为肯尼亚的 3 小时时差
    return 3
  }
  return offset
}

/**
 * 0时区转本地时区
 * @param {Date | string} date
 * @param {Object} config {
 *  offset: 偏移量(单位：h，默认为当前国家时区偏移量)
 *  format：默认 yyyy-MM-dd hh:mm:ss.SZ
 *  regionId: 自定义国家ID
 * }
 */
// export
export const zeroToLocalZonetime = (dt, config = {}) => {
  if (!dt) {
    return ''
  }
  if (getTypeof(dt) === 'String') {
    dt = new Date(dt)
    if (dt.toString() === 'Invalid Date') {
      return ''
    }
  }

  const timeOffset = getTimeOffset(config.regionId)
  const currentZonetimeOffset = (config.offset || timeOffset) * MS_OF_HOUR

  // 转换为0时区 + 当前时区偏移量
  const current = dt.getTime()
    + (dt.getTimezoneOffset() * 60 * 1000)
    + currentZonetimeOffset

  const t = formatDate(new Date(current), config.format || 'yyyy-MM-dd hh:mm:ss')

  return t
}

/**
 * 本地时区转0时区
 * @param {Date | string} date
 * @param {string} format default 'yyyy-MM-ddThh:mm:ss.SZ'
 */
export const localToZeroZonetime = (dt, format = 'yyyy-MM-ddThh:mm:ss.SZ') => {
  if (!dt) {
    return ''
  }
  let isZero = 1

  if (getTypeof(dt) === 'String') {
    isZero = /Z$/.test(dt) ? -1 : 1
    dt = new Date(dt)

    if (dt.toString() === 'Invalid Date') {
      return ''
    }
  }

  const current = dt.getTime()
    + (dt.getTimezoneOffset() * 60 * 1000)
    + ((getTimeOffset()) * MS_OF_HOUR * isZero)
  const t = formatDate(new Date(current), format)

  return t
}

/**
 * 获取指定日期开始时间和结束时间
 * @param {num} type 1 开始时间   2  结束时间
 * @param {*} config {
 *  format: 格式化日期,
 *  date: 指定偏移天数,
 *  offset：时区偏移量
 * }
 * @returns
 */
export const getEndOrStartTimeByTime = (type = 1, config = {}) => {
  const dt = new Date()
  if (dt.toString() === 'Invalid Date') {
    return ''
  }
  if (config.date && getTypeof(config.date) === 'Number') {
    dt.setDate(dt.getDate() + config.date)
  }
  const date = formatDate(dt, 'yyyy-MM-dd')
  const hs = type === 1 ? '00:00:00.000' : '23:59:59.999'
  const newDt = new Date(`${date}T${hs}Z`)

  const current = newDt.getTime()
    + (dt.getTimezoneOffset() * 60 * 1000)
    - ((config.offset || getTimeOffset()) * MS_OF_HOUR)

  const t = formatDate(new Date(current), config.format
  || `yyyy-MM-ddThh:mm:ss.SZ`)

  return t
}

/**
 * 获取最近 x 天的开始时间和结束时间
 * @param {Number} num 天数
 * @returns
 */
export function getDifferenceTimeByDays(num) {
  if (typeof (num) !== 'number') return ['', '']
  const today = new Date()
  const diffTime = new Date(today)
  // 如果是最近 x 天 (x > 1)，则是包含今天在内的 x 天，所以往前推 x - 1 天
  // 如果是 1 (昨天)，则往前推 1 天
  const days = num > 1 ? num - 1 : num
  diffTime.setDate(today.getDate() - days)
  return [
    localToZeroZonetime(diffTime, 'yyyy-MM-dd'),
    localToZeroZonetime(today, 'yyyy-MM-dd')
  ]
}

/**
 * 本地时区转浏览器时区
 * @param {*} dt
 * @param {*} format
 * @returns
 */
export const zeroToBrowserZonetime = (dt, format) => {
  if (!dt) {
    return ''
  }
  if (getTypeof(dt) === 'String') {
    dt = new Date(dt)
    if (dt.toString() === 'Invalid Date') {
      return ''
    }
  }

  return formatDate(dt, format || 'yyyy-MM-dd hh:mm:ss')
}

/**
 * 浏览器时区转 0 时区 UTC
 * @param {*} dt
 * @returns
 */
export const browserToZeroZonetime = (dt, format) => {
  if (!dt) {
    return ''
  }
  if (getTypeof(dt) === 'String') {
    dt = new Date(dt)
    if (dt.toString() === 'Invalid Date') {
      return ''
    }
  }

  const tt = dt.getTime() + dt.getTimezoneOffset() * 60 * 1000
  return formatDate(new Date(tt), format || 'yyyy-MM-ddThh:mm:ss.SZ')
}

const installTimezone = {
  install: (app) => {
    setApp(app)
    app.prototype.$tz = {
      zeroToLocalZonetime,
      getTimeOffset,
      localToZeroZonetime,
      getEndOrStartTimeByTime,
      formatDate,
      getDifferenceTimeByDays,
      zeroToBrowserZonetime,
      browserToZeroZonetime
    }
  }
}

Vue.use(installTimezone)

export default ({ app }) => {
  setApp(app)
  app.$tz = {
    zeroToLocalZonetime,
    localToZeroZonetime,
    getEndOrStartTimeByTime,
    formatDate,
    getTimeOffset,
    getDifferenceTimeByDays,
    zeroToBrowserZonetime,
    browserToZeroZonetime
  }
}
